export default "__VITE_ASSET__BUekF2LP__"